import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

export default class extends Controller {
  connect() {
    console.log("✅ Map controller connecté")

    this.center = { lat: 48.9231, lon: 2.2530 }
    this.zones = { comportementaliste: 20000, petsitting: 5000 }
    this.userMarker = null

    // Détection mobile pour ajuster le zoom
    const isMobile = window.innerWidth < 640
    const zoom = isMobile ? 9 : 11   // zoom plus petit sur mobile

    // Initialisation carte
    this.map = L.map(this.element).setView([this.center.lat, this.center.lon], zoom)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map)

    // Cercles zones
    this.mapZones = {
      comportementaliste: L.circle([this.center.lat, this.center.lon], {
        color:'#ef4444', fillColor:'#ef4444', fillOpacity:0.15, radius:this.zones.comportementaliste
      }).addTo(this.map),
      petsitting: L.circle([this.center.lat, this.center.lon], {
        color:'#3b82f6', fillColor:'#3b82f6', fillOpacity:0.25, radius:this.zones.petsitting
      }).addTo(this.map)
    }

    // Marqueur central
    L.marker([this.center.lat, this.center.lon]).addTo(this.map)
      .bindPopup("📍 Colombes (92)")
      .openPopup()

    // Input et suggestions
    this.input = document.getElementById("city-input")
    this.suggestions = document.getElementById("suggestions")
    this.message = document.getElementById("service-message")

    this.input.addEventListener("input", () => this.onInput())
  }

  async onInput() {
    const query = this.input.value
    this.suggestions.innerHTML = ""
    this.suggestions.classList.add("hidden")

    if (query.length < 2) return

    try {
      const res = await fetch(`https://geo.api.gouv.fr/communes?nom=${encodeURIComponent(query)}&fields=nom,centre,codeDepartement&limit=5&format=json`)
      const data = await res.json()
      if (!data.length) return

      data.forEach(city => {
        if (!city.centre) return
        const li = document.createElement("li")
        li.textContent = `${city.nom} (${city.codeDepartement})` // ville + département
        li.className = "px-4 py-2 hover:bg-gray-600 cursor-pointer"
        li.addEventListener("click", () => this.selectCity(city))
        this.suggestions.appendChild(li)
      })

      this.suggestions.classList.remove("hidden")
    } catch (e) {
      console.error(e)
    }
  }

  selectCity(city) {
    const lat = city.centre.coordinates[1]
    const lon = city.centre.coordinates[0]

    // Supprimer ancien marqueur
    if (this.userMarker) this.map.removeLayer(this.userMarker)
    this.userMarker = L.marker([lat, lon])
      .addTo(this.map)
      .bindPopup(`📍 ${city.nom} (${city.codeDepartement})`)
      .openPopup()
    this.map.setView([lat, lon], 12)

    // Vérification zones
    const distance = this.getDistance(lat, lon, this.center.lat, this.center.lon)
    const inPetsitting = distance <= this.zones.petsitting
    const inComportementaliste = distance <= this.zones.comportementaliste




    if (inPetsitting && inComportementaliste) {
      this.message.innerHTML = `<span style="color:green">Vous êtes dans la zone Pet-sitting et Comportementale.</span>`
    } else if (!inPetsitting && inComportementaliste) {
      this.message.innerHTML = `<span style="color:#32CD32">Vous êtes dans la zone Comportementaliste/Éducateur</span> <span style="color:red">mais en dehors de la zone Pet-sitting.</span>`
    } else {
      this.message.innerHTML = `<span style="color:red">Votre ville est en dehors de mes zones d’intervention.</span>`
    }

    // Cacher suggestions
    this.suggestions.innerHTML = ""
    this.suggestions.classList.add("hidden")
    this.input.value = `${city.nom} (${city.codeDepartement})`
  }

  getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371000
    const φ1 = lat1 * Math.PI / 180
    const φ2 = lat2 * Math.PI / 180
    const Δφ = (lat2 - lat1) * Math.PI / 180
    const Δλ = (lon2 - lon1) * Math.PI / 180
    const a = Math.sin(Δφ/2)**2 + Math.cos(φ1)*Math.cos(φ2)*Math.sin(Δλ/2)**2
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
    return R * c
  }
}
